import type { AdditionalFieldType } from "@/types/additionalFields";

/**
 * フィールドタイプの選択肢
 */
export const FIELD_TYPE_OPTIONS: Array<{
  value: AdditionalFieldType;
  label: string;
}> = [
  { value: "text", label: "テキスト（一行）" },
  { value: "textarea", label: "テキストエリア（複数行）" },
  { value: "number", label: "数値" },
  { value: "date", label: "日付" },
  { value: "datetime", label: "日時" },
  { value: "boolean", label: "はい/いいえ" },
];

/**
 * フィールドタイプから表示ラベルを取得
 */
export const getFieldTypeLabel = (fieldType: AdditionalFieldType): string => {
  return (
    FIELD_TYPE_OPTIONS.find((opt) => opt.value === fieldType)?.label ??
    fieldType
  );
};
